'use client';

import React from "react";
import Image from "./Image";

const AlternateImageDetails = ({ sections }) => {
  return (
    <>
      <div className="mx-auto px-4 sm:px-8 md:px-12 lg:px-16 max-w-7xl mt-10">
        {sections.map((s, i) => (
          <Section key={i} {...s} reverse={i % 2 !== 0} />
        ))}
      </div>
    </>
  );
};

export default AlternateImageDetails;

const Section = ({ title, content, image, reverse }) => (
  <div
    className={`flex flex-col ${
      reverse ? "md:flex-row-reverse" : "md:flex-row"
    } md:items-center justify-center gap-3 md:gap-8 mx-4 my-3 py-4 relative`}
  >
    <div className="w-full md:w-[40%] h-44 sm:h-56">
      <Image
        src={image}
        alt={title}
        className="object-cover h-full w-full rounded-lg shadow-lg transition-all duration-500 border border-color-97"
      />
    </div>
    <div className="w-full md:w-[50%] p-6 relative">
      <h2 className="text-2xl lg:text-4xl font-medium mb-4">{title}</h2>
      <div className="text-color-2 leading-relaxed">{content}</div>

      <div
        className={`pointer-events-none absolute -bottom-20 right-10 -rotate-45 w-[300px] h-[300px] bg-[radial-gradient(circle,_var(--accent-2-transparent-1),_var(--secondary-bg),_var(--accent-dark))] blur-3xl opacity-20`}
      ></div>
      <div
        className={`pointer-events-none absolute top-0 left-0 -rotate-45 w-[300px] h-[200px] bg-[radial-gradient(circle,_var(--accent-2-transparent-1),_var(--accent-dark))] blur-3xl opacity-10`}
      ></div>
    </div>
  </div>
);
